import { useState, useEffect } from 'react';
import { RED, BLUE, STATS, CAPTURED } from '../../../constants';
import { Pane, Panel, Avatar } from './styles';

/**
 * player: RED or BLUE
 */
const PlayerSection = ({ G, ctx, player }) => {
  const [seed, setSeed] = useState();
  useEffect(() => {
    setSeed(Date.now());
  }, []);
  const opposingPlayer = player === RED ? BLUE : RED;
  const bgColor = player === RED ? 'cc0000' : '0000cc';
  const avatarType = player === RED ? 'avataaars' : 'bottts';
  return (
    <Pane>
      <Panel player={player} isCurrent={ctx.currentPlayer === player}>
        <Avatar
          src={`https://avatars.dicebear.com/api/${avatarType}/${seed}.svg?colors=blue&background=%23${bgColor}&radius=50`}
          alt="Robot"
        />
        {ctx.currentPlayer === player ? (
          <p>{STATS[player].name.toUpperCase()} PLAYER</p>
        ) : (
          <p>{STATS[player].name} Player</p>
        )}
        <p>
          Captured:
          {
            G.pieces.filter(
              (p) => p.color === opposingPlayer && p.currentPos === CAPTURED
            ).length
          }{' '}
          of 6
        </p>
        {ctx.gameover?.winner === player && (
          <p>{STATS[player].name.toUpperCase()} WINS</p>
        )}
      </Panel>
    </Pane>
  );
};

export default PlayerSection;
